import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const navItems = [
  { to: "/#rutas", label: "Rutas" },
  { to: "/#como-funciona", label: "Cómo funciona" },
  { to: "/#nosotros", label: "Nosotros" },
  { to: "/#showcase", label: "App móvil" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-[#0D0E10]/85 border-b border-[#2E2F33]"
      data-testid="landing-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo size="md" />

        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((n) => (
            <a
              key={n.label}
              href={n.to}
              className="text-sm font-body font-medium text-[#A0A0A5] hover:text-[#F5F5F5] transition-colors uppercase tracking-wider"
              data-testid={`nav-link-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/login"
            className="px-4 py-2 text-sm font-body font-medium text-[#F5F5F5] hover:text-[#C9A227] transition-colors uppercase tracking-wider"
            data-testid="nav-login-btn"
          >
            Iniciar sesión
          </Link>
          <Link
            to="/registro"
            className="px-4 py-2 text-sm font-body font-medium border border-[#2E2F33] rounded-lg text-[#F5F5F5] hover:border-[#C9A227] hover:text-[#C9A227] transition-all uppercase tracking-wider"
            data-testid="nav-register-btn"
          >
            Registrarse
          </Link>
          <Link
            to="/cliente"
            className="px-5 py-2.5 text-sm font-display font-bold bg-[#C9A227] hover:bg-[#D4AF37] text-[#0D0E10] rounded-lg transition-colors uppercase tracking-wider"
            data-testid="nav-reserve-btn"
          >
            Reservar ahora
          </Link>
        </div>

        <button
          className="lg:hidden text-[#F5F5F5] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#2E2F33] bg-[#0D0E10] px-6 py-6 flex flex-col gap-4">
          {navItems.map((n) => (
            <a
              key={n.label}
              href={n.to}
              onClick={() => setOpen(false)}
              className="text-sm text-[#A0A0A5] uppercase tracking-wider"
            >
              {n.label}
            </a>
          ))}
          <div className="hr-gold my-2" />
          <Link to="/login" className="text-sm text-[#F5F5F5] uppercase tracking-wider">Iniciar sesión</Link>
          <Link to="/registro" className="text-sm text-[#F5F5F5] uppercase tracking-wider">Registrarse</Link>
          <Link to="/cliente" className="mt-2 px-5 py-3 text-sm font-display font-bold bg-[#C9A227] text-[#0D0E10] rounded-lg text-center uppercase tracking-wider" data-testid="mobile-reserve-btn">
            Reservar ahora
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
